import { assign } from '@atds-legacy/lang';
import { Record } from '@redge-media/fo-js-sdk';
import {
  bookmark,
  country,
  cover,
  defaultBookmark,
  favourite,
  genre,
  tag,
} from '@/shared/libs/helpers';

const Clip = Record.mixin(cover, genre, country, tag).extend({
  constructor: function Vod(attrs = {}, opts = {}) {
    Record.call(this, assign(attrs, {
      favourite: false,
      bookmark: attrs.bookmark || assign({}, defaultBookmark),
    }), opts);

    assign(this, favourite(this), bookmark(this));
  },
});

export default Clip;
